import { Diff } from '@/util/object.util';
import { DynamicTimetableRowDTO } from '@model/dynamicTimeTable/DynamicTimetableRowDTO';
import { DynamicTimetableCellDTO } from '@model/dynamicTimeTable/DynamicTimetableCellDTO';
import { BriefDynamicTimetableDTO } from '@model/dynamicTimeTable/BriefDynamicTimetableDTO';

export enum DynamicTimeTableCanvasHistoryItemType {
  BRIEF_CHANGE = 'BRIEF_CHANGE',

  ROW_ADD = 'ROW_ADD',
  ROW_DELETE = 'ROW_DELETE',
  ROW_CHANGE = 'ROW_CHANGE',
  ROW_VISIBILITY_CHANGE = 'ROW_VISIBILITY_CHANGE',

  CELL_ADD = 'CELL_ADD',
  CELL_DELETE = 'CELL_DELETE',
  CELL_CHANGE = 'CELL_CHANGE',
  CELL_ORDER_CHANGE = 'CELL_ORDER_CHANGE',
  CELL_VISIBILITY_CHANGE = 'CELL_VISIBILITY_CHANGE',
}

interface BriefChange {
  type: DynamicTimeTableCanvasHistoryItemType.BRIEF_CHANGE;
  diff: Diff<BriefDynamicTimetableDTO>;
}

interface RowAdd {
  type: DynamicTimeTableCanvasHistoryItemType.ROW_ADD;
  id: number;
}

interface RowDelete {
  type: DynamicTimeTableCanvasHistoryItemType.ROW_DELETE;
  row: DynamicTimetableRowDTO;
  index: number;
}

interface RowChange {
  type: DynamicTimeTableCanvasHistoryItemType.ROW_CHANGE;
  id: number;
  diff: Diff<DynamicTimetableRowDTO>;
  affectsChildren: boolean;
}

interface RowVisibilityChange {
  type: DynamicTimeTableCanvasHistoryItemType.ROW_VISIBILITY_CHANGE;
  id: number;
  visible: boolean;
}

interface CellAdd {
  type: DynamicTimeTableCanvasHistoryItemType.CELL_ADD;
  id: number;
  parentRowId: number;
}

interface CellDelete {
  type: DynamicTimeTableCanvasHistoryItemType.CELL_DELETE;
  cell: DynamicTimetableCellDTO;
  index: number;
}

interface CellChange {
  type: DynamicTimeTableCanvasHistoryItemType.CELL_CHANGE;
  id: number;
  diff: Diff<DynamicTimetableCellDTO>;
}

interface CellOrderChange {
  type: DynamicTimeTableCanvasHistoryItemType.CELL_ORDER_CHANGE;
  parentRowId: number;
  oldIndex: number;
  newIndex: number;
}

interface CellVisibilityChange {
  type: DynamicTimeTableCanvasHistoryItemType.CELL_VISIBILITY_CHANGE;
  id: number;
  visible: boolean;
}

export type DynamicTimeTableCanvasHistoryItem =
  | BriefChange
  | RowAdd
  | RowDelete
  | RowChange
  | RowVisibilityChange
  | CellAdd
  | CellDelete
  | CellChange
  | CellOrderChange
  | CellVisibilityChange;
